export default __webpack_public_path__ + "static/media/InfoGraphics.c135d56d806d8d287ff8282f46389daa.webp";